import { render, staticRenderFns } from "./fccAbaLocalDeProva.vue?vue&type=template&id=2543916c"
import script from "./fccAbaLocalDeProva.vue?vue&type=script&lang=js"
export * from "./fccAbaLocalDeProva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports